<div class="row">
    <div class="container">
        <h1 class="text-black" style="margin-bottom: 14px; margin-left: 25px;">Mis cotizaciones</h1>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <form class="row" [formGroup]="myQuoteDate">
                    <div class="col-xs-12 col-md-4">
                        <mat-label>Fecha Desde</mat-label>
                        <mat-form-field appearance="outline">
                            <input matInput [min]="minDate" [max]="maxDate" formControlName="fecha_inicio"
                                [matDatepicker]="picker1" placeholder="DD/MM/AAAA">
                            <mat-hint style="color: red"
                                *ngIf="myQuoteDate.hasError('greaterTheStartDate') && (myQuoteDate.get('fecha_inicio')?.touched || myQuoteDate.get('fecha_fin')?.touched)">
                                {{startDateErrorsMsg}}
                            </mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <mat-label>Fecha Hasta</mat-label>
                        <mat-form-field appearance="outline">
                            <input matInput [min]="minDate" [max]="maxDate" formControlName="fecha_fin"
                                [matDatepicker]="picker2" placeholder="DD/MM/AAAA">
                            <mat-hint style="color: red"
                                *ngIf="(myQuoteDate.hasError('greaterTheStartDate') || myQuoteDate.hasError('daysExceeded')) && (myQuoteDate.get('fecha_inicio')?.touched || myQuoteDate.get('fecha_fin')?.touched)">
                                {{endDateErrorsMsg}}
                            </mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <mat-label>Estado de la cotización</mat-label>
                        <mat-form-field appearance="outline">
                            <mat-label>Seleccione una opción</mat-label>
                            <mat-select [(value)]="selectedEstado" (selectionChange)="buscarCotizaciones(true)">
                                @for (estado of estadosList; track estado) {
                                <mat-option [value]="estado">{{estado}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <mat-label>Tipo de solicitud</mat-label>
                        <mat-form-field appearance="outline">
                            <mat-label>Seleccione una opción</mat-label>
                            <mat-select [formControl]="tipoSolicitudControl" multiple
                                (selectionChange)="buscarCotizaciones(true)">
                                @for (tipo of tiposSolicitud; track tipo.idTipoSolicitud) {
                                <mat-option [value]="+tipo.tipoSolicitud">{{tipo.nombreTipoSolicitud}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <mat-label>Línea de negocio</mat-label>
                        <mat-form-field appearance="outline">
                            <mat-label>Seleccione una opción</mat-label>
                            <mat-select [formControl]="toppings" multiple (selectionChange)="buscarCotizaciones(true)">
                                @for (topping of toppingList; track topping) {
                                <mat-option [value]="topping">{{topping}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <mat-label>Probabilidad de cierre</mat-label>
                        <mat-form-field appearance="outline">
                            <mat-label>Seleccione una opción</mat-label>
                            <mat-select [(value)]="selectedProbabilidad" (selectionChange)="buscarCotizaciones(true)">
                                @for (probabilidad of probabilidadesList; track probabilidad) {
                                <mat-option [value]="probabilidad">{{probabilidad}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                </form>

                <div class="row align-items-center justify-content-end ">
                    <div class="col-xs-12 col-md-4 ">
                        <form [formGroup]="myQuoteSearch">
                            <mat-form-field class="example-full-width" appearance="outline">
                                <input matInput formControlName="searchEngine" placeholder="Buscador general"
                                    (keyup.enter)="buscarCotizaciones(true)">
                                <mat-error *ngIf="fieldsValidatorsSearch('searchEngine')">
                                    <label>
                                        {{searchEngineErrosMsg}}
                                    </label>
                                </mat-error>
                            </mat-form-field>
                        </form>
                    </div>
                    <div class="col-xs-12 col-md-1 d-flex align-items-stretch">
                        <button mat-icon-button class="btnSearch match-search-height export-btn"
                            (click)="buscarCotizaciones(true)">

                            <mat-icon>
                                search
                            </mat-icon>
                        </button>
                    </div>

                    <div class="col-xs-12 col-md-2 d-flex align-items-stretch">
                        <button mat-raised-button class="background-blue match-search-height export-btn"
                            (click)="resetFilters()">
                            LIMPIAR

                        </button>
                    </div>
                    <div class="col-xs-12 col-md-2 d-flex align-items-stretch">
                        <button mat-raised-button class="background-blue match-search-height export-btn"
                            (click)="exportarCotizaciones()">
                            EXPORTAR
                            <mat-icon style="font-size:20px; line-height:1;">file_download</mat-icon>
                        </button>
                    </div>


                </div>

                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <!-- Vista de tabla para desktop/tablet -->
                        <div class="mat-elevation-z8">
                            <table mat-table [dataSource]="dataSource">

                                <!-- numero_cotizacion Column -->
                                <ng-container matColumnDef="numero_cotizacion">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        NÚMERO DE COTIZACIÓN </th>
                                    <td mat-cell *matCellDef="let element"> {{element.numero_cotizacion}} </td>
                                </ng-container>

                                <!-- fecha Column -->
                                <ng-container matColumnDef="fecha">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        FECHA </th>
                                    <td mat-cell *matCellDef="let element"> {{element.fecha}} </td>
                                </ng-container>

                                <!-- nombre_contratante Column -->
                                <ng-container matColumnDef="nombre_contratante">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        NOMBRE DEL CONTRATANTE </th>
                                    <td mat-cell *matCellDef="let element"> {{element.nombre_contratante}} </td>
                                </ng-container>

                                <!-- no_documento Column -->
                                <ng-container matColumnDef="no_documento">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center; font-weight: bold;">
                                        NO. DOCUMENTO </th>
                                    <td mat-cell *matCellDef="let element"> {{element.no_documento}} </td>
                                </ng-container>

                                <!-- tipo_solicitud Column -->
                                <ng-container matColumnDef="tipo_solicitud">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        TIPO DE SOLICITUD </th>
                                    <td mat-cell *matCellDef="let element"> {{element.tipo_solicitud}} </td>
                                </ng-container>

                                <!-- linea_negocio Column -->
                                <ng-container matColumnDef="linea_negocio">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        LÍNEA DE NEGOCIO </th>
                                    <td mat-cell *matCellDef="let element"> {{element.linea_negocio}} </td>
                                </ng-container>

                                <!-- estado Column -->
                                <ng-container matColumnDef="estado">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        ESTADO </th>
                                    <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
                                </ng-container>

                                <!-- probabilidad_cierre Column -->
                                <ng-container matColumnDef="probabilidad_cierre">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        PROBABILIDAD DE CIERRE </th>
                                    <td mat-cell *matCellDef="let element"> {{element.probabilidad_cierre}} </td>
                                </ng-container>

                                <!-- seguimiento Column -->
                                <ng-container matColumnDef="seguimiento">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold;">
                                        SEGUIMIENTO </th>
                                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                                        <div class="seguimiento-container"
                                            [ngClass]="{'seguimiento-clickable': element.colorSemaforo !== 'none'}"
                                            (click)="element.colorSemaforo !== 'none' ? openDialogSeguimiento(element) : null">
                                            <span class="seguimiento-texto">{{element.seguimiento}}</span>
                                            <span *ngIf="element.colorSemaforo !== 'none'" class="semaforo-circulo"
                                                [ngClass]="{
                                                    'semaforo-rojo': element.colorSemaforo === 'red',
                                                    'semaforo-amarillo': element.colorSemaforo === 'yellow',
                                                    'semaforo-verde': element.colorSemaforo === 'green',
                                                    'semaforo-gris': element.colorSemaforo === 'gray'
                                                  }">
                                            </span>

                                        </div>
                                    </td>
                                </ng-container>

                                <!-- acciones Column -->
                                <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef
                                        style="text-align: center;  font-weight: bold; background-color: #0273b7;">
                                        ACCIONES </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="acciones-cell">
                                            <button mat-icon-button matTooltip="Ver" (click)="viewQuote(element)"
                                                style="min-width: auto; padding: 0; color: #0273b7;">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                            <span matTooltip="Editar" [matTooltipDisabled]="cotizacionSoloLectura(element)">
                                                <button mat-icon-button
                                                    [disabled]="cotizacionSoloLectura(element)"
                                                    (click)="editQuote(element)"
                                                    style="min-width: auto; padding: 0;">
                                                    <mat-icon [style.color]="cotizacionSoloLectura(element) ? '#9e9e9e' : '#0273b7'">edit_square</mat-icon>
                                                </button>
                                            </span>
                                            <span matTooltip="Cierre de cotización" [matTooltipDisabled]="cotizacionSoloLectura(element)">
                                                <button mat-icon-button
                                                    [disabled]="cotizacionSoloLectura(element)"
                                                    (click)="openDialogCierreCotizacion(element)"
                                                    style="min-width: auto; padding: 0;">
                                                    <mat-icon [style.color]="cotizacionSoloLectura(element) ? '#9e9e9e' : '#0273b7'">grading</mat-icon>
                                                </button>
                                            </span>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                <!-- Mensaje cuando no hay datos -->
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" [attr.colspan]="displayedColumns.length"
                                        style="text-align: center; padding: 20px; color: #666;">
                                        No se encontraron cotizaciones con los filtros aplicados.
                                    </td>
                                </tr>
                            </table>

                            <mat-paginator #paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons
                                [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                                aria-label="Select page of quotations">
                            </mat-paginator>
                        </div>

                        <!-- Vista de cards para móviles -->
                        <div class="mobile-cards-container">
                            <div *ngIf="dataSource.data.length > 0; else noDataMobile">
                                <div *ngFor="let element of dataSource.data" class="mobile-card">
                                    <!-- Header del card -->
                                    <div class="mobile-card-header">
                                        <div class="mobile-card-number">#{{element.numero_cotizacion}}</div>
                                        <div class="mobile-card-date">{{element.fecha}}</div>
                                    </div>

                                    <!-- Body del card -->
                                    <div class="mobile-card-body">
                                        <div class="mobile-card-row">
                                            <div class="mobile-card-label">Contratante</div>
                                            <div class="mobile-card-value">{{element.nombre_contratante}}</div>
                                        </div>

                                        <div class="mobile-card-row">
                                            <div class="mobile-card-label">Documento</div>
                                            <div class="mobile-card-value">{{element.no_documento}}</div>
                                        </div>

                                        <div class="mobile-card-row">
                                            <div class="mobile-card-label">Tipo de solicitud</div>
                                            <div class="mobile-card-value">{{element.tipo_solicitud}}</div>
                                        </div>

                                        <div class="mobile-card-row">
                                            <div class="mobile-card-label">Línea de negocio</div>
                                            <div class="mobile-card-value">{{element.linea_negocio}}</div>
                                        </div>

                                        <div class="mobile-card-row">
                                            <div class="mobile-card-label">Estado</div>
                                            <div class="mobile-card-estado">{{element.estado}}</div>
                                        </div>

                                        <div class="mobile-card-row">
                                            <div class="mobile-card-label">Probabilidad de cierre</div>
                                            <div class="mobile-card-value">{{element.probabilidad_cierre}}</div>
                                        </div>

                                        <div class="mobile-card-row">
                                            <div class="mobile-card-label">Seguimiento</div>
                                            <div class="mobile-card-seguimiento"
                                                [ngClass]="{'seguimiento-clickable': element.colorSemaforo !== 'none'}"
                                                (click)="element.colorSemaforo !== 'none' ? openDialogSeguimiento(element) : null">
                                                <span class="mobile-card-value">{{element.seguimiento}}</span>
                                                <span *ngIf="element.colorSemaforo !== 'none'" class="semaforo-circulo"
                                                    [ngClass]="{
                                                        'semaforo-rojo': element.colorSemaforo === 'red',
                                                        'semaforo-amarillo': element.colorSemaforo === 'yellow',
                                                        'semaforo-verde': element.colorSemaforo === 'green',
                                                        'semaforo-gris': element.colorSemaforo === 'gray'
                                                      }">
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Acciones -->
                                    <div class="mobile-card-actions">
                                        <button mat-raised-button (click)="viewQuote(element)">
                                            <mat-icon>visibility</mat-icon>
                                            Ver
                                        </button>
                                        <span matTooltip="Editar" [matTooltipDisabled]="cotizacionSoloLectura(element)">
                                            <button mat-raised-button
                                                [disabled]="cotizacionSoloLectura(element)"
                                                (click)="editQuote(element)">
                                                <mat-icon>edit_square</mat-icon>
                                                Editar
                                            </button>
                                        </span>
                                        <span matTooltip="Cierre de cotización" [matTooltipDisabled]="cotizacionSoloLectura(element)">
                                            <button mat-raised-button
                                                [disabled]="cotizacionSoloLectura(element)"
                                                (click)="openDialogCierreCotizacion(element)">
                                                <mat-icon>grading</mat-icon>
                                                Cerrar
                                            </button>
                                        </span>
                                    </div>
                                </div>

                                <!-- Paginador móvil -->
                                <mat-paginator #paginatorMobile [pageSizeOptions]="[10, 25, 50, 100]"
                                    showFirstLastButtons [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                                    aria-label="Select page of quotations">
                                </mat-paginator>
                            </div>

                            <ng-template #noDataMobile>
                                <div class="mobile-no-data">
                                    No se encontraron cotizaciones con los filtros aplicados.
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>



            </div>
        </div>



    </div>
</div>